module.exports = __webpack_public_path__ + "static/img/ic_noti_send@2x.51a86e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_noti_send@2x.png
// module id = fVqI
// module chunks = 1